import useSVG from "../../hooks/useSVG";

import "./style.css";

function GoalOptionTile({ label, svg, className }) {
    const { UseGoal } = useSVG();

    return (
        <div className={`goal-option-tile ${className}`}>
            {UseGoal(svg)}
            <h5>{label}</h5>
        </div>
    );
}

export default GoalOptionTile;